import { ParceirosPublicFaq } from './ParceirosPublicFaq'
import { ParceirosPublicHero } from './ParceirosPublicHero'
import { ParceirosPublicPortal } from './ParceirosPublicPortal'
import { ParceirosPublicClose, ParceirosPublicStory } from './ParceirosPublicStory'

export function ParceirosPublicHome() {
  return (
    <div className='grid gap-14'>
      <ParceirosPublicHero />
      <ParceirosPublicStory />
      <div className='grid items-start gap-10 lg:grid-cols-2 lg:gap-8'>
        <ParceirosPublicPortal />
        <ParceirosPublicFaq />
      </div>
      <ParceirosPublicClose />
    </div>
  )
}
